import { useCallback } from 'react'

import { useSegment } from '../../../hooks'
import { InvoicingSettingsSection } from '../enums/invoicingSettingsSection'

const trackingSectionNameBySection: Record<InvoicingSettingsSection, string> = {
  [InvoicingSettingsSection.Compliance]: 'Compliance',
  [InvoicingSettingsSection.EInvoicing]: 'E-invoicing',
  [InvoicingSettingsSection.Invoice]: 'Invoice',
  [InvoicingSettingsSection.LogoAndBranding]: 'Logo & branding',
  [InvoicingSettingsSection.PaymentsAndReminders]: 'Payments & reminders',
  [InvoicingSettingsSection.Presets]: 'Presets',
  [InvoicingSettingsSection.Quote]: 'Quote',
}

interface UseTrackInvoicingSettingsProps {
  // Set by the settings modal's sections. The old settings page and the invoice editor leave it out,
  // so their event names stay without a section.
  section?: InvoicingSettingsSection
}

export const useTrackInvoicingSettings = ({ section }: UseTrackInvoicingSettingsProps = {}) => {
  const { track } = useSegment()

  const trackInvoicingSettings = useCallback(
    (eventDetail: string, payload?: Record<string, any>) => {
      const trackingSectionName = section ? `${trackingSectionNameBySection[section]} section - ` : ''

      track(`XXX - Invoicing Core - Invoicing Settings - ${trackingSectionName}${eventDetail}`, {
        ...payload,
      })
    },
    [section, track],
  )

  return { trackInvoicingSettings }
}
